import { SafePromise } from '@benzinga/safe-await';
import { StockSymbol } from '@benzinga/session';
import { ChartDataResponse } from '../entities';
import { proxyClientOptions, RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { ChartEnvironment } from '../environment';
import { DateTime } from 'luxon';
import { chartRoutes } from './routes';

export class BarsRestful extends RestfulClient {
  constructor(session: Session) {
    const env = session.getEnvironment(ChartEnvironment);
    super(env.barsUrl, session, {}, proxyClientOptions(undefined, 'token'));
  }

  getBars = (
    symbol: StockSymbol,
    params: { to?: string; from?: string; interval?: string },
  ): SafePromise<ChartDataResponse[]> => {
    const env = this.session.getEnvironment(ChartEnvironment);
    const to = params.to ? DateTime.fromFormat(params.to, 'yyyy-MM-dd') : undefined;
    const from = params.from ? DateTime.fromFormat(params.from, 'yyyy-MM-dd') : undefined;

    const path = this.routePath(chartRoutes.bars);
    const url = this.URL(
      path,
      this.withUpstreamCredentials(
        {
          from: from && from.isValid ? from.toFormat('yyyy-MM-dd') : '',
          interval: params.interval ? params.interval : '5M',
          symbols: symbol,
          to: to && to.isValid ? to.toFormat('yyyy-MM-dd') : undefined,
        },
        { token: env.barsKey },
      ),
    );
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorization: true },
    });
  };
}
